import { render, staticRenderFns } from "./NenTangDichVuForm.vue?vue&type=template&id=148628b2"
import script from "./NenTangDichVuForm.vue?vue&type=script&lang=js"
export * from "./NenTangDichVuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports